import { Component, Inject, forwardRef } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'offline-request-synchronizer-dialog',
    template: require('./offline-request-synchronizer-dialog.component.html')
})
export class OfflineRequestSynchronizerDialogComponent {

    counter: number;
    total: number;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<OfflineRequestSynchronizerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.counter = data.counter;
        this.total = data.total;
    }

    increaseCounter(): void {
        this.counter = this.counter + 1;
    }

}